import SquadflixVideoPlayer from "../squadflixVideoPlayer/squadflixVideoPlayer";
import {canUsePlayer, getEmbedUrl, worksInSandBox} from "../../../utils/legalServers";
import React, {useEffect} from "react";
import TowersStreamViewer from "./towersStreamViewer/towersStreamViewer";
import VeronlineStreamPlayer from "./veronlineStreamPlayer/veronlineStreamPlayer";
import Player4uPlayer from "./player4uPlayer/player4uPlayer";
import AIOStreamViewer from "./AIOStreamViewer/AIOStreamViewer";

import './towersStreamViewer.css';
import "/node_modules/flag-icons/css/flag-icons.min.css";

const SquadflixVideoView = ({
                                selectedServer,
                                imagePath,
                                file,
                                type,
                                tmdbId,
                                season,
                                episode,
                                item,
                                onGoNextEpisode,
                                squadFlixTvHook
                            }) => {

    useEffect(() => {
        const originalOpen = window.open;

        window.open = function (url, name, features) {
            console.warn("Bloqueado intento de abrir ventana:", url);
            return null; // Bloquea la apertura de la nueva ventana
        };

        return () => {
            window.open = originalOpen; // Restaurar funcionalidad original al desmontar el componente
        };
    }, []);

    return (<div className="squadflix-video-viewer">
        {selectedServer === 'SquadFlix' && <div className="squadflix-video-viewer__container">
            <SquadflixVideoPlayer onGoNextEpisode={onGoNextEpisode} posterPath={imagePath} file={file}
                                  item={item}
                                  squadFlixTvHook={squadFlixTvHook}></SquadflixVideoPlayer>
        </div>}
        {canUsePlayer(selectedServer, 'veronlineStreamPlayer') && <div className="squadflix-video-viewer__container">
            <VeronlineStreamPlayer type={type} tmdbId={tmdbId} episode={episode} season={season} imagePath={imagePath}
                                   item={item} onGoNextEpisode={onGoNextEpisode} squadFlixTvHook={squadFlixTvHook}/>
        </div>
        }
        {canUsePlayer(selectedServer, 'AIOStreamViewer') && <div className="squadflix-video-viewer__container">
            <AIOStreamViewer type={type} tmdbId={tmdbId} episode={episode} season={season} imagePath={imagePath}
                             item={item} onGoNextEpisode={onGoNextEpisode} squadFlixTvHook={squadFlixTvHook}/>
        </div>
        }
        {canUsePlayer(selectedServer, 'towersStreamViewer') && <div className="squadflix-video-viewer__container">
            <TowersStreamViewer type={type} tmdbId={tmdbId} episode={episode} season={season} imagePath={imagePath}
                                item={item} onGoNextEpisode={onGoNextEpisode} squadFlixTvHook={squadFlixTvHook}/>
        </div>
        }
        {canUsePlayer(selectedServer, 'player4u') && <div className="squadflix-video-viewer__container">
            <Player4uPlayer item={item} searchUrl={getEmbedUrl(selectedServer, type, tmdbId, season, episode, item)}
                            imagePath={imagePath}/>
        </div>
        }
        {canUsePlayer(selectedServer, 'iframe') && <div className="squadflix-video-viewer__container">
            {<iframe style={{width: "100%", aspectRatio: "16/9"}}
                     allowFullScreen
                     {...(worksInSandBox(selectedServer) ? {sandbox: "allow-scripts allow-same-origin"} : {})}
                     src={getEmbedUrl(selectedServer, type, tmdbId, season, episode, item)}></iframe>}
        </div>
        }
    </div>)
}

export default SquadflixVideoView;
